<template>
  <div class="article_box">
    <h1 class="article_title">{{articleArr.title}}</h1>
    <viewer :images="imgArr">
      <div class="article_content" v-html="articleArr.content">
      </div>
    </viewer>
  </div>
</template>
<script>
import http from "../../util/hermerApiConfig";
import cheerio from "cheerio";
import $ from "jquery";
export default {
  data() {
    return {
      article_id: null,
      articleArr: [],
      meta_title: "",
      commentArr: [],
      comments_count: 0,
      imgArr: [],
      good_type: null,
      good_id: null,
      goodArr: []
    };
  },
  metaInfo() {
    return {
      title: this.meta_title
    };
  },
  created() {
    this.article_id = this.$route.query.id;
    let good_id = this.$route.query.good_id;
    if (good_id) {
      this.good_id = this.$route.query.good_id;
    }
    let good_type = this.$route.query.good_type;
    if (good_type) {
      this.good_type = this.$route.query.good_type;
    }
    this.getpageinfo();
    // this.getinfo();
    // this.getcomment();
    // this.iinit();
  },
  mounted() {
    let that = this
    $(document).on("click", ".xiaoe", function() {
      let obj = {
        type:that.good_type
      }
      if(this.good_type == 2){
        obj['id'] = that.good_id
      }else{
        obj['id'] = that.goodArr.good_alias
      }
      that.$appUtils.appOpenMiniProgram(obj)
    });
  },
  methods: {
    getinfo() {
      let url = "/articles/" + this.article_id;
      http.get(url).then(res => {
        if (res.data.status_code == 200) {
          this.meta_title = res.data.data.title;
          this.articleArr = res.data.data;
          this.iinit();
        }
      });
    },
    getpageinfo() {
      let url = "/goods/package/";
      let params = {
        article_id: this.article_id
      };
      if (this.good_id != null) {
        params["good_type"] = this.good_type;
        params["good_id"] = this.good_id;
      }
      let that = this;
      http.get(url, { params }).then(res => {
        if (res.data.status_code == 200) {
          this.articleArr = res.data.data.article;
          this.goodArr = res.data.data.good;
          this.iinit();
          if(this.good_type == 2){
            var timer = setInterval(function() {
              if ($(".article_content p").length > 0) {
                console.log($(".article_content p").length)
                that.processing();
                clearInterval(timer);
              }
            }, 100);
          }
          this.$appUtils.appCloseLoadingView()
        }
      });
    },
    processing() {
      let len = $(".article_content p").length
      console.log(len)
      let number = Math.ceil(Math.random()*len);
      if(number==len||number==0){
        number = Math.round(len/2);
      }
      console.log(number)
      let domstr = ''
      if(this.good_type==2){
        domstr = `<p class="xiaoe">
          <span class="xiaoe_img" style="background:url('${this.goodArr.img_url_compress}');"></span>
          <span class="xiaoe_box">
            <span class="xiaow_title">${this.goodArr.title}</span>
            <span class="xioae_zj">${this.goodArr.summary}</span>
            <span class="xiaoe_view"
              >${this.goodArr.view_count}人开通<em
                >￥${this.resetprice(this.goodArr.price)}</em
              >
            </span>
          </span>
        </p>`
      }else if(this.good_type==4){
        domstr = `<p class="xiaoe">
          <span class="xiaoe_img" style="background:url('${this.goodArr.img_url_compress}');"></span>
          <span class="xiaoe_box">
            <span class="xiaow_title">${this.goodArr.title}</span>
            <span class="xioae_zj">${this.goodArr.introduce}</span>
            <span class="xiaoe_view2"
              >￥${this.resetprice(this.goodArr.line_price)}<br/><em
                >￥${this.resetprice(this.goodArr.price)}</em
              >
            </span>
            <span class="xiaoe_view3">
            立即购买
            </span>
          </span>
        </p>`
      }
      $("p").eq(number).before(domstr);
    },
    getcomment() {
      let url = "/articles/" + this.article_id + "/comments";
      http.get(url).then(res => {
        // console.log(res);
        if (res.data.status_code == 200) {
          if (JSON.stringify(res.data.data) !== "{}") {
            this.commentArr = res.data.data.comments;
            this.comments_count = res.data.data.comments_count;
          }
          //   console.log(this.commentArr);
        }
      });
    },
    resetprice(price) {
      let fs = parseFloat(price);
      if (isNaN(fs)) {
        return false;
      }
      let f = Math.round(price * 100) / 100;
      let s = f.toString();
      let rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    },
    distance(day) {
      //过去的时间戳
      var now = new Date(day * 1000); //过去 //年
      var year = now.getFullYear(); //月
      var month = now.getMonth() + 1; //日
      var date = now.getDate(); //时
      var hour = now.getHours(); //分
      var minute = now.getMinutes(); //秒
      var second = now.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      var timer = month + "-" + date + " " + hour + ":" + minute;

      return timer;
    },
    godownload() {
      this.$router.push({
        path: "/download"
      });
    },
    iinit() {
      let that = this;
      let $ = cheerio.load(this.articleArr.content);
      // console.log($('img').attr('src'))
      $("img").each(function(idx, element) {
        let $element = $(element);
        // console.log($element.attr("src"));
        that.imgArr.push($element.attr("src"));
      });
        // console.log(this.imgArr);
    }
  }
};
</script>
<style lang="scss" scoped>
.article_box {
  padding: 0px 16px;
}
.article_title{
  font-size: 23px;
  color: #333;
  margin-top: 20px;
  margin-bottom: 16px;
  font-weight: bold;
}
.article_content {
  // white-space: pre-wrap; /* css3.0 */
  // white-space: -moz-pre-wrap; /* Firefox */
  // white-space: -pre-wrap; /* Opera 4-6 */
  // white-space: -o-pre-wrap; /* Opera 7 */
  // word-wrap: break-word;
}
.article_comment {
  border-top: 2px solid #e6e6e6;
  padding: 24px 16px 0px;
}
</style>
<style>
.xiaoe {
  width: 100%;
  height: 118px;
  display: flex;
  margin: 15px auto;
}
.xiaoe_img {
  width: 118px;
  height: 118px;
  margin-right: 14px;
  border-radius: 4px;
  background-size: cover !important;;
  background-repeat: no-repeat !important;;
  background-position: center center !important;;
}
.xiaoe_box {
  width: calc(100% - 132px);
  height: 118px;
  /* display: flex; */
  position: relative;
}
.xiaoe_box span {
  display: block;
}
.xiaow_title {
  color: #333;
  font-size: 14px;
}
.xioae_zj {
  margin-top: 6px;
  color: #808080;
  font-size: 12px;
}
.xiaoe_view {
  width: 100%;
  height: 18px !important;
  line-height: 18px;
  color: #999;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.xiaoe_view em {
  font-weight: normal;
  color: #fa3737;
  font-size: 16px;
  position: absolute;
  right: 10px;
  bottom: 0;
}
.xiaoe_view2 {
  line-height: 18px;
  color: #fa3737;
  font-size: 16px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.xiaoe_view3 {
  width: 70px;
  height: 23px;
  border-radius: 23px;
  line-height: 23px;
  background: #fa3737;
  color: #fff;
  font-size: 12px;
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: center;
}
.xiaoe_view2 em {
  font-weight: normal;
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/article/article.vue